
import { onMounted } from 'vue';
import GraphComponent from '@/components/GraphView.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { GraphComponent },
})
export default class cteGraphPrint extends Vue {
  public graphTitle: string = 'Gráfico de Lucratividade';
  public selectedChartType: string = 'column';
  public isGraphInverted: boolean = false;
  public graphLoading: boolean = false;
  public isAuthorized: boolean = true;
  public categories: string[] = [];
  public seriesData: any[] = [];
  public yAxisLabel: string = 'Values';
  setup() {
    onMounted(() => {
      window.print();
      window.onafterprint = () => window.close();
    });
  }
}
